import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const TaggableSchema = withDefaults({
  type: 'taggable',
  fields: [
    {
      kind: 'hasMany',
      name: 'tags',
      type: 'tag',
      options: {
        async: false,
        inverse: 'taggable',
        as: 'taggable',
      },
    },
  ],
});

export default TaggableSchema;
